import * as tagPromoBannerActions from '../../action_creators/tag/tag_promo_banner_action_creators';
import TagPromoBannerModel from '../../../models/tag/tag_promo_banner';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagPromoBannerActions.tagPromoBannerLoading({}, store));
    return TagPromoBannerModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(tagPromoBannerActions.tagPromoBannerLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(tagPromoBannerActions.tagPromoBannerLoadError(err, store));
        log.error(
          err,
          `Error in tagPromoBanner actions, message: ${err.message}`
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/tag/async_tag_promo_banner_actions.js